import { render, staticRenderFns } from "./ProductPosts.vue?vue&type=template&id=67c68b31&scoped=true"
import script from "./ProductPosts.vue?vue&type=script&lang=js"
export * from "./ProductPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c68b31",
  null
  
)

export default component.exports